export default __webpack_public_path__ + "static/media/admin.e92f1a90.png";